import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vtiger-crm-dev',
  templateUrl: './vtiger-crm-dev.component.html',
  styleUrls: ['./vtiger-crm-dev.component.css']
})
export class VtigerCrmDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/vtiger-crm-dev/vtiger-crm-dev.component.ts